import { render, staticRenderFns } from "./chat-notification.vue?vue&type=template&id=00a2a36e&"
import script from "./chat-notification.vue?vue&type=script&lang=js&"
export * from "./chat-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports